import { all, call, put, takeLatest } from "redux-saga/effects";

import {
  approveRecruitmentRequirementStart,
  approveRecruitmentRequirementSuccess,
  approveRecruitmentRequirementFailed,
} from "../redux/approveRecruitmentRequirement";

import { approveRecruitmentRequirementApi } from "core/http/service/recruitment";
import { resetControlPage } from "components/common/ListInfinitiveScrolling/redux/controlInfinitiveScrolling";
import {
  getListRecruitmentRequirementStart,
  resetListRecruitmentRequirement,
} from "../redux/getListRecruitmentRequirement";
import { toast } from "react-toastify";

function* approveRecruitmentRequirementWork(
  action: ReturnType<typeof approveRecruitmentRequirementStart>
) {
  try {
    const res = yield call(approveRecruitmentRequirementApi, action.payload);
    yield put({
      type: approveRecruitmentRequirementSuccess.type,
      payload: {
        data: res.data,
      },
    });
    yield put({
      type: resetListRecruitmentRequirement.type,
    });
    yield put({
      type: resetControlPage.type,
      payload: "recruitmentRequirement",
    });
    yield put({
      type: getListRecruitmentRequirementStart.type,
    });
    toast.success("Duyệt yêu cầu tuyển dụng thành công!");
  } catch (error: any) {
    yield put({
      type: approveRecruitmentRequirementFailed.type,
    });
  }
}

function* watchApproveRecruitmentRequirement() {
  yield takeLatest(
    approveRecruitmentRequirementStart.type,
    approveRecruitmentRequirementWork
  );
}

export default function* approveRecruitmentRequirementSaga() {
  yield all([watchApproveRecruitmentRequirement()]);
}
